<template>
  <div class="vx-row ml-0">
    <div class="vx-col p-8  vx-card">
      <div class="vx-row ml-4"><span class="title_card">{{$t('generalSettingMenu.btn3')}}</span></div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full ml-4 mb-3">
          <span class="font-semibold" style="font-size: 16px;margin-left: -1rem;">{{$t('generalSettingMenu.language')}}</span>
        </div>
        <div class="vx-row w-full ml-6">
          <div class="md:w-1/12">
            <div class="mt-2">
              <feather-icon class="p-1" icon="MessageSquareIcon" style=" display: flex;justify-content: center; background-color: #E5F5EC;color: #27AE60;transform: scale(1.6);border-radius: 3px;width:25px; height:25px"></feather-icon>
            </div>
          </div>
          <div class="md:w-2/3">
            <div class="vx-col w-full">
              <span class="opacity-75" style="font-size: 12px">Ngôn ngữ mặc định là Tiếng Việt. Bạn có thể chuyển sang Tiếng Anh. </span>
            </div>
            <div class="vx-col w-full">
              <span class="opacity-75" style="font-size: 12px">Default language is Vietnamese, you may switch to English upon your preferences.</span>
            </div>
          </div>
          <div class="md:w-1/4">
            <div  style="display: flex;">
              <span style="white-space: nowrap;">{{$t('generalSettingMenu.vn')}}</span>
              <vs-switch  @click="updateLocale()" class="ml-2 mr-2" v-model="activeI18n"></vs-switch>
              <span>English</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Display",
  data(){
    return{
      activeI18n:false
    }
  },
 created() {
    if (this.$i18n.locale == 'vn') {
      this.activeI18n = false
    }
    if(this.$i18n.locale == 'en') {
        this.activeI18n = true
    }
 },
  methods: {
    updateLocale () {
      // let locale = null;
      // if (this.activeI18n == true){
      //     locale = 'vn'
      // } else {
      //      locale ='en'
      // }
      // this.$i18n.locale = locale
      // this.$eventBus.$emit("i18n", locale);
      // if (locale === 'en') locale = 'en-US';
      // if (locale === 'vn') locale = 'vi-VN';
      // localStorage.setItem("language", locale)
    }
  }
}
</script>

<style scoped>
.title_card{
  font-weight: bold;
  font-size: 28px;
  margin-left: -1rem;
}
</style>
